module.exports = __webpack_public_path__ + "assets/img/credit-card-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/credit-card-logo.png
// module id = 73
// module chunks = 0